import { LanguageDictionary } from "@core/idtek-component";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import Footer from "../component/Footer";
import { useAppContext } from "../hook/useAppContext";
import AppUtil from "../util/AppUtil";

import { useLocation, useNavigate } from "react-router-dom";
import AppHeader from "../component/AppHeader";
import AppRouter from "../component/AppRouter";
import HeaderMobile from "../component/HeaderMobile";
import { useBookingInfoContext } from "../hook/useBookingInfoContext";
import "../style/loading.scss";
import LoadingMask from "./LoadingMask";

const Layout = (props: any): JSX.Element => {
  const { appState, setAppState } = useAppContext()!;
  const { bookingInfoState, setBookingInfoState } = useBookingInfoContext()!;
  const [loading, setLoading] = useState(true);
  const [GlobalStyles, setGlobalStyles] = useState(createGlobalStyle`
      html {
      }
    `);
  const navigate = useNavigate();
  const locationCurrent = useLocation();

  useEffect(() => {
    setLoading(false);
    //loadLanguage()
  }, []);

  const loadLanguage = async () => {
    setAppState({ ...appState, isShowThemes: false });
    if (locationCurrent.pathname === "/") {
      navigate("/booking/idbeauty?action=set-booking");
    }
    const res = await AppUtil.getApi("/booking-online/get-language", {
      locationCode: appState.locationCode,
    });
    if (_.get(res, "data.success")) {
      const result = _.get(res, "data.result");
      if (
        _.get(result, "language") &&
        !_.isEmpty(_.get(result, "dictionary"))
      ) {
        moment.locale("en");
        LanguageDictionary.setDictionary(result.dictionary, result.language);
        setAppState({ ...appState, isShowThemes: true });
      }
    }
  };

  const checkLogin = async () => {
    const resAuthData = await AppUtil.getApi("/identity-online/check-login");
    if (_.get(resAuthData, "data.success")) {
      const data = _.get(resAuthData, "data.result");
      if (_.get(data, "authData")) {
        const dataUser = _.get(data, "authData.user");
        setAppState({ user: dataUser });
        setBookingInfoState({
          phone: dataUser?.phone || dataUser?.phoneNumber,
          customerName: dataUser?.customerName || dataUser?.fullName,
          email: dataUser?.email || null,
        });
      }
    }
  };

  const fetchLocation = async () => {
    setAppState({ loading: true });
    const response = await AppUtil.getApi(
      "/location-online/get-location-by-code",
      { locationCode: appState.locationCode }
    );
    if (_.get(response, "data.success") && _.get(response, "data.result")) {
      const location = _.get(response, "data.result");
      const GlobalStyles = createGlobalStyle`
              html {
                --theme-color: ${location.themeColor};
                --theme-background-color: ${location.themeBackgroundColor};
                --theme-color-boxshadow: ${location.themeShadowColor};
                --theme-color2: ${location.themeColor2}
              }
            `;
      setGlobalStyles(GlobalStyles);
      setAppState({
        location: location,
        option: AppUtil.RegexPhone(location.regexPhone),
      });
    } else {
      //navigate({pathname: "/not-found"})
    }
    setTimeout(() => {
      setAppState({ loading: false });
    }, 300);
  };

  useEffect(() => {
    const checkIsMobile =
      navigator.userAgent.match(/Android/i) !== null ||
      navigator.userAgent.match(/webOS/i) !== null ||
      navigator.userAgent.match(/iPhone/i) !== null ||
      navigator.userAgent.match(/iPad/i) !== null ||
      navigator.userAgent.match(/iPod/i) !== null ||
      navigator.userAgent.match(/BlackBerry/i) !== null ||
      navigator.userAgent.match(/Windows Phone/i) !== null;
    setAppState({ isMobile: checkIsMobile });
  }, [navigator.userAgent]);

  useEffect(() => {
    appState.locationCode && fetchLocation();
    appState.locationCode && loadLanguage();
  }, [appState.locationCode]);

  useEffect(() => {
    checkLogin();
  }, []);

  if (loading) {
    return (
      <>
        <div
          className={`body-v2 d-flex flex-fill row margin-unset-h loading-relative ${
            appState.isMobile ? "full-loading-mobile" : "full-loading"
          } `}
          style={{
            // marginTop: appState.isShowThemes ? 20 : 0,
            // marginBottom: appState.isShowThemes && !appState.isMobile ? 59 : 0,
            // minHeight: appState.isShowThemes && !appState.isMobile ? 'calc(100vh - 160px)' : '100%'
            overflowX: "hidden",
          }}
        >
          <LoadingMask />
        </div>
      </>
    );
  }

  return (
    <>
      <GlobalStyles />
      {appState.isShowThemes &&
        (appState.isMobile ? <HeaderMobile /> : <AppHeader />)}
      <div
        className={`body-v2 d-flex flex-fill row margin-unset-h loading-relative ${
          appState.isMobile ? "full-loading-mobile" : "full-loading"
        } `}
        style={{
          // marginTop: appState.isShowThemes ? 20 : 0,
          // marginBottom: appState.isShowThemes && !appState.isMobile ? 59 : 0,
          // minHeight: appState.isShowThemes && !appState.isMobile ? 'calc(100vh - 160px)' : '100%'
          overflowX: "hidden",
        }}
      >
        <LoadingMask />
        <AppRouter {...props} />
      </div>
      {appState.isShowThemes && <Footer />}
    </>
  );
};

export default Layout;
